<template>
  <div>
    <v-container v-if="!horizontal">
      <apexchart
        type="bar"
        :options="options"
        :series="data"
        height="350"
      ></apexchart>
    </v-container>
    <div class="mt-7" v-else style="width:89%; overflow:">
      <apexchart
        type="bar"
        :options="options"
        :series="data"
        length="500"
        :height="height"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'labels', 'title', 'customOptions', 'horizontal', 'height'],
  computed: {
    ...mapGetters({
      _options: 'charts/getBarChart',
    }),
    options() {
      const options = { ...this._options };
      options.xaxis = this.xaxis;
      // options.title.text = this.title;
      this.customOptions ? (options.colors = this.customOptions.colors) : '';
      options.colors[0] = this.$vuetify.theme.currentTheme.primary;
      options.colors[1] = this.$vuetify.theme.currentTheme.secondary;
      if (this.horizontal) {
        let high = 0;
        this.data.map(series => {
          series.data.map(point => {
            if (point > high) {
              high = point;
            }
          });
        });
        options.plotOptions = {
          bar: {
            barHeight: '80%',
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          },
        };
        options.chart = {
          redrawOnParentResize: true,
        };
        options.stroke = {
          show: true,
          width: 3,
          colors: ['#fff'],
        };
        options.dataLabels = {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['black'],
            fontWeight: 'bold',
            outline: 'black',
          },
          formatter(val, opt) {
            if (opt.seriesIndex === 0) {
              return `Total Clicks: ${
                opt.w.globals.series[opt.seriesIndex][opt.dataPointIndex]
              }`;
            }
            return `Total Mins: ${
              opt.w.globals.series[opt.seriesIndex][opt.dataPointIndex]
            }`;
          },
          offsetX: 20,
        };
        options.yaxis = {
          labels: {
            show: false,
          },
        };
        options.xaxis = {
          max: high + (high / 100) * 20,
          categories: this.labels,
          labels: {
            formatter(val) {
              return Math.abs(Math.round(val));
            },
          },
        };
        options.tooltip = {
          y: {
            formatter(value, { seriesIndex, dataPointIndex, w }) {
              if (seriesIndex === 0) {
                return `Total Clicks: ${w.globals.series[seriesIndex][dataPointIndex]}`;
              }
              return `Total Mins: ${w.globals.series[seriesIndex][dataPointIndex]}`;
            },
            title: {
              formatter(value, { w, dataPointIndex }) {
                return w.globals.labels[dataPointIndex];
              },
            },
          },
        };
      } else {
        options.tooltip = {
          y: {
            formatter(value, { seriesIndex, dataPointIndex, w }) {
              return w.globals.series[seriesIndex][dataPointIndex];
            },
            title: {
              formatter(value, { w, dataPointIndex }) {
                return w.globals.labels[dataPointIndex];
              },
            },
          },
        };
      }
      this.customOptions
        ? (options.yaxis.title.text = this.customOptions.ytitle)
        : '';
      return options;
    },
    xaxis() {
      return { categories: this.labels };
    },
  },
};
</script>
